export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      communities: [
        {
          communityUuid: "community002",
          communityNumber: "1002",
          name: "アイラ地域サポート",
          note: "xxxxxx",
          status: 1,
          createdAt: 1594880785395,
          tenant: {
            tenantUuid: "tenant001",
            name: "xxxxxx",
            nameKana: "xxxxxx",
            status: 1
          },
          deviceTypes: [
            {
              deviceTypeUuid: "xxxxxx",
              modelNumber: "xxxxxx",
              modelName: "JS01H",
              manufacturerName: "xxxxxx",
              status: 1,
              createdAt:1594880785395
            },
            {
              deviceTypeUuid: "xxxxxx",
              modelNumber: "xxxxxx",
              modelName: "JH01K",
              manufacturerName: "xxxxxx",
              status: 1,
              createdAt:1594880785395
            }
          ],
          communityTantous: [
            {
              userUuId: "xxxxxx",
              name: "どい",
              status: 1
            }
          ]
        },
        {
          communityUuid: "community001",
          communityNumber: "1001",
          name: "○○地域サポート",
          note: "xxxxxx",
          status: 1,
          createdAt: 1594880785395,
          tenant: {
            tenantUuid: "tenant002",
            name: "xxxxxx",
            nameKana: "xxxxxx",
            status: 1
          },
          deviceTypes: [
            {
              deviceTypeUuid: "xxxxxx",
              modelNumber: "xxxxxx",
              modelName: "JS01H",
              manufacturerName: "xxxxxx",
              status: 1,
              createdAt:1594880785395
            }
          ],
          communityTantous: [
            {
              userUuId: "xxxxxx",
              name: "相良　太郎",
              status: 1
            }
          ]
        }
      ]
    }
  }
}